import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Structure } from 'src/app/core/_models/structure';

@Component({
  selector: 'app-dialog-structure',
  templateUrl: './dialog-structure.component.html',
  styleUrls: ['./dialog-structure.component.scss']
})
export class DialogStructureComponent implements OnInit {
  form: any;
  currentItem: Structure = {};

  constructor(
    public dialogRef: MatDialogRef<DialogStructureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.form = this.formBuilder?.group({
      structureId: [null],
      displayName: ['', Validators.required]
    });

    if (this.data?.structure) {
      this.currentItem = this.data.structure;
      this.form.reset();
      this.form.patchValue(this.currentItem);
    }
  }

  get formCrls() {
    return this.form?.controls;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
